export default (function () {
  return 0;
});